var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterSolid = function SvgTwitterSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_solid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6.078a13.107 13.107 0 0 1-3.77 1.033 6.576 6.576 0 0 0 2.886-3.632 13.151 13.151 0 0 1-4.17 1.594 6.554 6.554 0 0 0-4.791-2.074c-4.239 0-7.354 3.955-6.396 8.06-5.455-.273-10.292-2.886-13.531-6.858a6.574 6.574 0 0 0 2.03 8.765 6.536 6.536 0 0 1-2.971-.821c-.072 3.04 2.108 5.886 5.265 6.52a6.58 6.58 0 0 1-2.965.112 6.57 6.57 0 0 0 6.133 4.558A13.2 13.2 0 0 1 0 26.055a18.586 18.586 0 0 0 10.064 2.95c12.19 0 19.076-10.295 18.66-19.528A13.366 13.366 0 0 0 32 6.077Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_solid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .002)",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgTwitterSolid;